var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:12;stroke-miterlimit:10;}\r\n\t.st1{stroke:#000000;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -53.0193 128)",
    className: "st0",
    cx: 128,
    cy: 128,
    rx: 116,
    ry: 116
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.5,101c0-5.7,4.6-10.2,10.2-10.2c5.7,0,10.2,4.6,10.2,10.2s-4.6,10.2-10.2,10.2 C70.1,111.2,65.5,106.7,65.5,101z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170,101c0-5.7,4.6-10.2,10.2-10.2c5.7,0,10.2,4.6,10.2,10.2s-4.6,10.2-10.2,10.2 C174.6,111.2,170,106.7,170,101z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.9,157l-15.4-29L50,157c-2.5,4.6-3.8,7.1-3.8,11.4c0,10.6,8.6,19.2,19.2,19.2c10.6,0,19.2-8.6,19.2-19.2 C84.7,164.1,83.7,162.3,80.9,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.3,147.4c9.5-6.1,20.8-9.6,32.9-9.6c13.6,0,26.2,4.4,36.4,12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/Sad.0a9338a4e0fea77af4322406efc49ec0.svg";
export { ForwardRef as ReactComponent };